
import { ResultData } from "@nt-portal/common-sdk";

import { ValidateResult } from "@nt-portal/common-sdk";
import { DbInuseResult, TCMMasterGroupItem, TCMMasterGroupItemService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { createTCMMasterGroup } from "./master-group.service";

export interface TCMMasterGroupItemOptions extends ControllerOptions<TCMMasterGroupItem> {
    importMode?: string;
    sheetId?: string;
}

export const createTCMMasterGroupItem = (inObj: Partial<TCMMasterGroupItem>) => {
    let item: TCMMasterGroupItem = {
        itemNumber: inObj.itemNumber ?? "",
        sheet: inObj.sheet,
        createdBy: "",
        group: inObj.group ?? createTCMMasterGroup({})
    }
    return item;
}


export class ClientTCMMasterGroupItemService extends BaseClientService implements DataController<TCMMasterGroupItem> {

    private _service: TCMMasterGroupItemService;


    constructor() {
        super();
        this._service = new TCMMasterGroupItemService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }


    public init(inObj: Partial<TCMMasterGroupItem>): TCMMasterGroupItem {
        return createTCMMasterGroupItem(inObj);
    }

    public async get(options: TCMMasterGroupItemOptions): Promise<ResultData<TCMMasterGroupItem>> {

        if (this.params.groupId)
            return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.sheetId);
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }

    }

    public async getLookup(options: TCMMasterGroupItemOptions): Promise<ResultData<TCMMasterGroupItem>> {


        if (this.params.groupId) {
            let fetchParams = this.buildLookupFetchParams(options);
            let data = await this._service.get(fetchParams, this.token, options.filter, options.sheetId);
            return data;
        }
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }

    public async getById(options: TCMMasterGroupItemOptions): Promise<TCMMasterGroupItem | null> {
        if (options.id && this.params.groupId) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMMasterGroupItemOptions): Promise<any> {
        if (options.id && this.params.groupId)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMMasterGroupItemOptions): Promise<TCMMasterGroupItem | TCMMasterGroupItem[] | null> {
        if (options.item && options.item.id && this.params.groupId)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }

     public async validate(itemNumber: string, id?: string): Promise<ValidateResult | null> {
        if (this.params.groupId)
            return await this._service.validateItemNumber(itemNumber, this.token, id)
        return null;
    }
    public async add(options: TCMMasterGroupItemOptions): Promise<TCMMasterGroupItem | TCMMasterGroupItem[] | null> {
        if (options.item && this.params.groupId)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async inUse(options: TCMMasterGroupItemOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        } else {
            throw new Error("ID is required for inUse check");
        }
    }



    public async import(options: TCMMasterGroupItemOptions): Promise<any> {



        if (options.file && this.params.groupId) {

            return await this._service.importExcel(options.file, options.importMode ?? "simple", this.token);



        }
    }


    public async export(options: TCMMasterGroupItemOptions): Promise<any> {
        if (this.params.groupId) {
            let fetchParams = this.buildLookupFetchParams(options);
            return await this._service.export(this.token, fetchParams, options.filter);
        }
        return null;
    }



}